import { trackEvent, EVENTS, EVENT_IDS } from "~/common/analytics"
import { ReactNode } from "react"
import { Link } from "react-router-dom"
import { isRambleBrand } from "~/common/brand"
import logo from "~/images/landing/logo"

interface LogoProps {
  analyticsProps?: Record<string, string | undefined>
  className?: string
  src?: string
  alt?: string
  children?: ReactNode
}

export const Logo = ({
  analyticsProps = {},
  className = "h-[40px]",
  src = logo.src,
  alt = "Logo",
  children,
}: LogoProps) => {
  const handleLogoPress = () => {
    trackEvent(EVENTS.ITEM_PRESSED, {
      unique_id: EVENT_IDS.LOGO,
      ...analyticsProps,
    })
  }
  const linkClassName = children ? "flex flex-col items-start gap-0.5" : undefined
  const content = (
    <>
      <img src={src} alt={alt} className={className} />
      {children}
    </>
  )

  // The Ramble homepage is served by Rails at "/"; the client router's "/"
  // renders the ChatBCC landing screen, so navigate with a full page load.
  return isRambleBrand() ? (
    <a href="/" onClick={handleLogoPress} className={linkClassName}>
      {content}
    </a>
  ) : (
    <Link to="/" onClick={handleLogoPress} className={linkClassName}>
      {content}
    </Link>
  )
}
